/* ExecutionTypeComponent.js */

"use strict";
const _ = require("lodash");
const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl.DefaultColumnComponent;
const Renderer = require("./ExecutionTypeRenderer");

class ExecutionTypeComponent extends DefaultColumnComponent {
    constructor(value) {
        super(value);
        this._value = value;
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /* *****************************************
    /* START PUBLIC API METHODS
    /* ***************************************** */
    setValue(newVal) {
        if (!_.isUndefined(newVal)) {
            this.setExecutionType(newVal);
        }
    }

    getValue() {
        return this.getExecutionType();
    }

    setExecutionType(newVal) {
        this._value = newVal;
        this.emit("ExecutionType", newVal);
        return this;
    }

    getExecutionType() {
        return this._value;
    }

    /* *****************************************
    /* END PUBLIC API METHODS
    /* ***************************************** */
}

module.exports = ExecutionTypeComponent;
